import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { isEmpty, size } from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
const { SearchBar, ClearSearchButton } = Search;

// import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
// import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import {
  Badge,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Button,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import { map } from "lodash";

import { getStaffRequest } from "store/Staff/actions";
import { deleteStaffRequest } from "store/Staff/actions";
import { editStaffRequest } from "store/Staff/actions";

const MySearchBar = prop => {
  console.log(JSON.stringify(prop));
  let input;
  const handleClick = () => {
    prop.onSearch(input.value);
  };

  return (
    <div className="app-search">
      <div className="position-relative">
        <input
          type="text"
          className="form-control bg-white border border-3 shadow w-100"
          placeholder={"Search" + "..."}
          ref={n => (input = n)}
          onChange={handleClick}
        />
        <span className="bx bx-search-alt"></span>
      </div>
    </div>
  );
};
class StaffList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteModal: false,
      modal: false,
      subscribemodal: false,
      StaffListColumns: [
        {
          dataField: "email",
          text: "Email",
          sort: true,
          formatter: (
            cellContent,
            row //row= HomeSampler object
          ) => (
            <Link to="#" className="text-body fw-bold">
              {row.email}
            </Link>
          ),
        },
        {
          dataField: "name",
          text: "Name",
          sort: true,
        },
        {
          dataField: "contact_number",
          text: "Contact Number",
          sort: true,
        },

        {
          dataField: "CNIC",
          text: "CNIC",
          sort: true,
        },
        {
          dataField: "view",
          isDummyField: true,
          text: "View Details",
          sort: true,
          formatter: (cellContent, row) => (
            console.log({ pathname: `/staffdetails/${row.email}` }),
            (
              <Link
                to={{ pathname: `/staffdetails/${row.email}` }}
                className="btn btn-primary btn-sm btn-rounded"
              >
                View Details
              </Link>
            )
          ),
        },
        {
          dataField: "view2",
          isDummyField: true,
          sort: true,
          text: "Actions",
          formatter: (cellContent, row) => (
            <>
              <i
                onClick={() => this.handleStaffEditClick(row)}
                style={{
                  cursor: "pointer",
                }}
                className="mdi mdi-pencil font-size-16 text-success me-1"
              />
              <i
                onClick={() => {
                  this.onClickDelete(row);
                }}
                className="mdi mdi-trash-can font-size-16 text-danger me-1"
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleStaffEditClick = this.handleStaffEditClick.bind(this);
  }
  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  // Delete Service related Model
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };

  onClickDelete = Staffs => {
    this.setState({ Staffs: Staffs });
    this.setState({ deleteModal: true });
  };

  handleDeleteStaff = () => {
    const { onDeleteStaff } = this.props;
    const { Staffs } = this.state;
    if (Staffs.email !== undefined) {
      onDeleteStaff(Staffs);
      this.onPaginationPageChange(1);
      this.setState({ deleteModal: false });
    }
  };

  toggle() {
    //This is the function to open the modal
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }
  handleStaffEditClick = arg => {
    const Staff = arg;
    console.log(JSON.stringify(Staff));

    this.setState({
      Staff: {
        email: Staff.email,
        name: Staff.name,
        contact_number: Staff.contact_number,
        CNIC: Staff.CNIC,
      },
    });

    this.toggle();
  };
  handleStaffEditClicks = () => {
    this.setState({ Staff: "" });
    this.toggle();
  };

  toLowerCase1(str) {
    return str.toLowerCase();
  }

  componentDidMount() {
    const { Staffs, onGetStaff } = this.props;
    // TODO : Get the list of homesamplers and useremail being passed should be taken from the Auth Token
    if (Staffs && !Staffs.length) {
      onGetStaff();
    }
    this.setState({ Staffs });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { Staffs } = this.props;
    if (
      !isEmpty(Staffs) &&
      size(prevProps.Staffs) !== size(Staffs)
    ) {
      this.setState({ Staff: {} });
    }
  }

  toggleViewModal = () => {
    this.setState(prevState => ({
      viewmodal: !prevState.viewmodal,
    }));
  };

  render() {
    const { Staffs } = this.props; //getting the state from the props to display the data in the table
    const { deleteModal } = this.state;
    const Staff = this.state.Staff;
    //pagination customization
    const pageOptions = {
      sizePerPage: 20,
      totalSize: Staffs.length, // replace later with size(service),
      custom: true, //to hide the sizePerPage dropdown
    };

    const defaultSorted = [
      {
        dataField: "name",
        order: "asc",
      },
    ];

    // const selectRow = {
    //   mode: "checkbox",
    // };

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteStaff}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <Modal isOpen={this.state.modal} className={this.props.className}>
          <ModalHeader toggle={this.toggle} tag="h4">
            Edit Staff
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize={true} //this means that the form will be reinitialized if the props are updated
              initialValues={{
                email: (Staff && Staff.email) || "",
                name: (Staff && Staff.name) || "",
                contact_number:
                  (Staff && Staff.contact_number) || "",
                CNIC: (Staff && Staff.CNIC) || "",
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().required("Email is required"),
                name: Yup.string().required("Name is required"),
                contact_number: Yup.string().required(
                  "Contact Number is required"
                ),
                CNIC: Yup.string().required("CNIC is required"),
              })}
              onSubmit={values => {
                const updatedStaff = {
                  name: values.name,
                  CNIC: values.CNIC,
                  contact_number: values.contact_number,
                };

                this.props.onEditStaff(
                  updatedStaff,
                  Staff.email
                );

                this.toggle();
              }}
            >
              {({ errors, status, touched, values }) => (
                <Form>
                  <Row>
                    <Col className="col-12">
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Field
                          name="email"
                          type="text"
                          readOnly={true}
                          style={{
                            cursor: "not-allowed",
                          }}
                          className="form-control"
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Name</Label>
                        <Field
                          name="name"
                          type="text"
                          className={
                            "form-control" +
                            (errors.name && touched.name ? " is-invalid" : "")
                          }
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Contact Number</Label>
                        <Field
                          name="contact_number"
                          type="text"
                          className={
                            "form-control" +
                            (errors.contact_number && touched.contact_number
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="contact_number"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">CNIC</Label>
                        <Field
                          name="CNIC"
                          type="text"
                          className={
                            "form-control" +
                            (errors.CNIC && touched.CNIC ? " is-invalid" : "")
                          }
                        />
                        <ErrorMessage
                          name="CNIC"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn btn-primary save-user"
                        >
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>

        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Dashboard" breadcrumbItem="Staff" />
            {this.props.loading ? (
              <div className="text-center">
                <i
                  className="bx bx-loader bx-spin mt-5 "
                  style={{ fontSize: 48, color: "#2A3042" }}
                />
              </div>
            ) : this.props.Staffs.length > 0 ? (
              <Row>
                <Col lg="12">
                  <div>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="email"
                      columns={this.state.StaffListColumns}
                      data={Staffs}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="email"
                          data={Staffs}
                          columns={this.state.StaffListColumns || []}
                          bootstrap4
                          search={
                            {
                              // defaultSearch: "search something when the table loads for the first time",
                            }
                          }
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <div className="table-responsive">
                                <Row>
                                  <Col className="justify-content-center align-item-center ">
                                    <MySearchBar
                                      {...toolkitProps.searchProps}
                                    />
                                  </Col>
                                  <Col
                                    xs={2}
                                    className=" d-flex justify-content-end align-items-center"
                                  >
                                    <Link
                                      to="/registerStaff"
                                      className="btn btn-primary btn-rounded w-100 d-none d-xl-block"
                                    >
                                      <span className="fas fa-plus "></span>
                                      {"  "}Register Staff
                                    </Link>
                                    <Link
                                      to="/registerStaff"
                                      className="btn btn-primary w-100 btn-sm btn-rounded d-block px-3 py-2 d-xl-none"
                                    >
                                      <span
                                        className="fas fa-plus"
                                        style={{ width: 20 }}
                                      ></span>
                                    </Link>
                                  </Col>
                                </Row>

                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  defaultSorted={defaultSorted}
                                  bordered={false}
                                  striped={false}
                                //   selectRow={selectRow}
                                  classes={
                                    "table align-middle table-nowrap table-check"
                                  }
                                  headerWrapperClasses={"table-light"}
                                />
                              </div>
                              <div className="pagination pagination-rounded justify-content-end">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className="justify-content-center mt-5 d-flex flex-column">
                <Col lg="12">
                  <div className="text-center">
                    <Row className="justify-content-center">
                      <Col sm="6">
                        <h3> No Staff Found!</h3>
                        <p>Register one now</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col
                  sm={12}
                  className=" justify-content-center d-flex flex-column"
                >
                  <Link
                    to="/registerstaff"
                    className="btn btn-primary btn-rounded mx-auto"
                  >
                    <span className="fas fa-plus "></span> Register Staff
                  </Link>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
StaffList.propTypes = {
  t: PropTypes.any,
  onEditStaff: PropTypes.func,
  onDeleteStaff: PropTypes.func,
  history: PropTypes.object,
  className: PropTypes.any,
  onGetStaff: PropTypes.func,
  loading: PropTypes.bool,
  Staffs: PropTypes.array,
  Staff: PropTypes.object,
   
};

const mapStateToProps = state => ({
//   homesamplers: state.EmployeeReducer.homesamplers,
  Staffs: state.StaffReducer.Staffs,
  Staff: state.StaffReducer.Staff,
//   homesampler: state.EmployeeReducer.homesampler,
  loading: state.StaffReducer.isLoading,
  error: state.StaffReducer.error,
});

const mapDispatchToProps = dispatch => ({
  onGetStaff: () => dispatch(getStaffRequest()),
  onEditStaff: (Staff, email) =>{
    console.log("email",email)
    dispatch(editStaffRequest(Staff, email))},
  onDeleteStaff: email => {
    console.log("email in delete",email)
    dispatch(deleteStaffRequest(email))},
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StaffList));